module.exports = __webpack_public_path__ + "img/15.848e5b70.png";